/**
 * @file Token 统一处理
 * @date 2021-06-26
 */

import { cookie } from '@sfe/bone-cache';
import Hecate from '@bybit/hecate';
import { TOKEN_COOKIE_KEY } from '@/config/site';
import { COOKIE_MAIN_DOMAIN } from '@/config/env';
import { error as errorToast } from '@/utils/toast';

let token = null;

// 获取token信息，兼容目前websocket的登录依据，PC、H5端（不包含APP内嵌webview）其他地方不再使用token作为登录态判断依据
export const get = (init) => {
    // PC和H5端
    if (!window.sfe.isApp) {
        return Promise.resolve(cookie.get(TOKEN_COOKIE_KEY));
    }

    // APP内嵌webview
    if (!token && init) {
        return new Promise((resolve) => {
            Hecate
                .module('UserProfile')
                .method('getUserProfile')
                .invoke({ needLogin: false })
                .then((res) => {
                    token = res.params ? (res.params.userToken || '') : '';
                    resolve(token);
                })
                .catch(({ message }) => {
                    errorToast(message);
                    token = '';
                    resolve(token);
                });
        });
    }
    return Promise.resolve(token);
};

export const set = (value) => {
    cookie.set(TOKEN_COOKIE_KEY, value, {
        expires: 7, // 7天
        domain: COOKIE_MAIN_DOMAIN,
        secure: false, // 集团没有使用 HTTPS Cookie
    });
};

export const remove = () => {
    cookie.removeForce(TOKEN_COOKIE_KEY);

    try {
        if (window.sfe.isApp) {
            cookie.remove(TOKEN_COOKIE_KEY, {
                path: '/',
                domain: `.${window.location.host}`,
            });
            cookie.remove(TOKEN_COOKIE_KEY, {
                path: '/',
                domain: window.location.host,
            });
            token = '';
        }
    } catch (e) {} // eslint-disable-line
};
